import { Route, Routes } from 'react-router-dom'
import RequireRole from '../../common/components/RequireRole'
import { BackofficePermissionsEnum as Permissions } from '../../common/enums/backOfficePermissionsEnum'
import { ListProspects } from '../../modules/prospect/ListProspects'
import { SuspensedView } from '../PrivateRoutes'

export const ProspectRouting = () => {
  return (
    <Routes>
      <Route
        path='list'
        element={
          <RequireRole roles={Permissions.USER_PROSPECT.LIST}>
            <SuspensedView>
              <ListProspects />
            </SuspensedView>
          </RequireRole>
        }
      />
    </Routes>
  )
}
